import AccountDetails from 'apps/auth/components/ga/accounts/AccountDetails';
import BankTransferFinalStep from 'apps/auth/components/ga/accounts/topup/BankTransferFinalStep';
import GaTopUp from 'apps/auth/components/ga/accounts/topup/GaTopUp';
import TopUpByCardCalcStep from 'apps/auth/components/ga/accounts/topup/TopUpByCardCalcStep';
import TopUpByPlaid from 'apps/auth/components/ga/accounts/topup/TopUpByPlaid';
import TopUpByTrustly from 'apps/auth/components/ga/accounts/topup/TopUpByTrustly';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import TopUpByBankTransferPage from 'apps/auth/pages/ga/TopUpByBankTransferPage';
import TopUpByCardPage from 'apps/auth/pages/ga/TopUpByCardPage';
import TopUpByGooglePayPage from 'apps/auth/pages/ga/TopUpByGooglePayPage';

const gaAccountTopUp = [
    {
        path: '/auth/ga/pocket/:id/top-up/account-details',
        component: AccountDetails,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/card/:sourceId',
        component: TopUpByCardCalcStep,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/card',
        component: TopUpByCardPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/plaid',
        component: TopUpByPlaid,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/trustly',
        component: TopUpByTrustly,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/google-pay',
        component: TopUpByGooglePayPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/bank-transfer/final-step',
        component: BankTransferFinalStep,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up/bank-transfer',
        component: TopUpByBankTransferPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/ga/pocket/:id/top-up',
        component: GaTopUp,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            innerPage: true,
            isGA: true,
        },
    },
];
export default gaAccountTopUp;
